(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
  function build(root) {
    var bar = root.querySelector('[data-bardo-tabs-bar]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bardo-tab-panel]'));
    if (!bar || !panels.length) return;

    bar.innerHTML = '';
    var tabs = panels.map(function (panel, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bardo-tabs__tab';
      btn.setAttribute('role', 'tab');
      btn.textContent = panel.getAttribute('data-title') || ('Tab ' + (i + 1));
      bar.appendChild(btn);
      return btn;
    });

    function activate(idx) {
      panels.forEach(function (p, i) { p.hidden = i !== idx; });
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (n !== null) { e.preventDefault(); tabs[n].focus(); activate(n); }
      });
    });

    root._bardoActivate = activate;
    root.setAttribute('data-ready', '');
    activate(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bardo-tabs]').forEach(function (root) { build(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editor: re-render de sección/bloque
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var panel = (t.matches && t.matches('[data-bardo-tab-panel]')) ? t : (t.querySelector && t.querySelector('[data-bardo-tab-panel]'));
    if (!panel) return;
    var root = panel.closest('[data-bardo-tabs]');
    if (!root || !root._bardoActivate) return;
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bardo-tab-panel]'));
    root._bardoActivate(panels.indexOf(panel));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
